import { DateAsIsoString } from "./formikData";

export enum Product {
  Term = 1,
  CriticalIllness = 2
}

export enum ApplicationState {
  Quote = 1,
}

export enum Sex {
  NotKnown = 0,
  Male = 1,
  Female = 2,
  NotApplicable = 9,
}

export enum PremiumPaymentMode {
  Annual = 1,
  Monthly = 2
}

export interface IQuoteDto {
  id: number;
  state: ApplicationState;
  number: string | null;
  productId: number;
  productVariantId: number | null;
  advisorCode: string | null;
  advisorFirstName: string | null;
  advisorLastName: string | null;
  premiumPaymentMode: PremiumPaymentMode;
  coverages: ICoverageDto[];
  insureds: IInsuredDto[];
}

export interface IPersonDto {
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
  dateOfBirth: DateAsIsoString | null;
  sex: Sex | null;
}

export type InsuredRatingInfoDto = {
  permanent: number | null;
  temporal: number | null;
  percentageId: number | null;
  durationYears: number | null;
  isDeclined: boolean;
}


export interface ICoverageDto {
  id: number;
  planId: number;
  faceAmount: number | null;
  criticalIllnessRiderInfo: ICriticalIllnessRiderInfoDto | null;
  payorDisabilityWaiverOfPremiumRiderInfo: IPayorDisabilityWaiverOfPremiumRiderInfoDto | null;
  insuredIds: number[];
  isFirstCoverageOnApplication: boolean;
  isFirstCoverageOnInsured: boolean;
  ratingInfo: CoverageRatingInfoDto | null;
}

export type CoverageRatingInfoDto = {
  permanent: number | null;
  temporal: number | null;
  percentageId: number | null;
  durationYears: number | null;
}

export interface ICriticalIllnessRiderInfoDto {
  id: number;
  premiumTypeId: number;
  expiryAge: number;
}

export interface IPayorDisabilityWaiverOfPremiumRiderInfoDto {
  id: number;
  age: number | null;
  isSmoker: boolean | null;
  useBackDate: boolean;
  person: IPersonDto;
}

export interface IInsuredDto {
  id: number;
  age: number | null;
  isSmoker: boolean | null;
  useBackDate: boolean | null;
  person: IPersonDto;
  ratingInfo: InsuredRatingInfoDto | null;
}

export interface IQuoteCreateResult {
  id: number;
  number: string;
}

export type ApplicationCreateResult = {
  number: string;
  validationResults: ValidationResult[];
}

export type ValidationResult = {
  memberNames: string[];
  errorMessage?: string;
};
